<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.header" [separator]="false" />
    <email-margin [height]="14" />
    <table cellspacing="0" cellpadding="0" border="0">
      <tr>
        <ng-container *mailgunIf="data.avatar_url">
          <td align="left" width="48" height="48">
            <img
              class="avatar"
              width="48"
              height="48"
              [attr.src]="data.avatar_url.toJSON()"
              alt=""
            />
          </td>
          <td width="12">&nbsp;</td>
        </ng-container>
        <td align="left" class="web-notification-title">
          <email-text [contents]="data.title_html" className="web-rt-contains-link" />
        </td>
      </tr>
    </table>
  </ng-container>

  <ng-container body>
    <email-margin [height]="28" />
    <email-infobox [contents]="data.note_body_html" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="paragraph" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
